import { useState, useEffect } from "react";
import { Circle } from "rc-progress";
import { useItemProgressListener } from "@rpldy/uploady";

interface IUploadItemProgressProps {
  id?: string;
}

const UploadItemProgress = (props: IUploadItemProgressProps) => {
  const { completed } = useItemProgressListener(props.id) || {
    completed: 0,
  };
  const [progress, setProgess] = useState(completed);

  useEffect(() => {
    setProgess(completed);
  }, [completed]);

  return (
    <>
      <span style={{ width: "36px", height: "36px", marginRight: "10px" }}>
        <Circle
          percent={completed}
          strokeWidth={4}
          trailColor="rgb(175,180,176)"
          strokeColor={{
            "0%": "#fff",
            "100%": "#123210",
          }}
        />
      </span>
    </>
  );
};

export default UploadItemProgress;
